import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { BONOS, PRICING } from '../../data/content';
export function Bonos() {
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-15" data-mp="1hipuewkgrcdd">
      <div className="mx-auto max-w-5xl" data-id="element-16" data-mp="1hhepuuj720l7">
        <Reveal className="text-center" data-id="element-17" data-mp="1ckeh2buymjqe">
          <SectionBadge data-id="element-18" data-mp="1cilb6ys683jg">Regalo incluido</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-3xl leading-tight text-cocoa sm:text-5xl" data-id="element-19" data-mp="oubxyl90wo3x">
            Y además recibís <span className="italic text-terra" data-id="element-20" data-mp="jxli9z14ruj1">5 bonos exclusivos</span>
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="ym7u3qrju45i">
          {BONOS.map((bono, index) => <Reveal key={bono.n} delay={index % 3 * 60} as="article" data-id="element-22" data-mp="tsvhkf059nt4" data-mpi={index}>
              <div className="flex h-full flex-col overflow-hidden rounded-2xl border border-sand-line bg-cream-card" data-id="element-23" data-mp="63keurz8hjcc">
                <div className="flex aspect-[4/3] items-center justify-center bg-cream-deep p-4" data-id="element-24" data-mp="14zmfeq843yg">
                  <img src={bono.mockup} alt={`Portada del bono ${bono.n}: ${bono.title}`} width={400} height={300} loading="lazy" decoding="async" className="h-full w-full object-contain" data-id="element-25" data-mp="2z9w3y65k3ny0" />
                </div>

                <div className="flex flex-1 flex-col p-5" data-id="element-26" data-mp="392bo9a4bsom2">
                  <div className="flex items-center justify-between gap-2" data-id="element-27" data-mp="3d0r66zljv6sm">
                    <span className="text-[10px] font-extrabold uppercase tracking-[0.18em] text-terra-deep" data-id="element-28" data-mp="2gbtdro19vkym">Bono {bono.n}</span>
                    <span className="inline-flex items-center gap-1 rounded-full bg-olive-soft px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wide text-olive" data-id="element-29" data-mp="2lbo4nrl1sajo">
                      <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-30" data-mp="2ubucawu2egax" /> Incluido
                    </span>
                  </div>
                  <h3 className="mt-2.5 font-display text-xl leading-snug text-cocoa" data-id="element-31" data-mp="4l7ish7k8ilh">{bono.title}</h3>
                  <p className="mt-1 flex-1 text-sm leading-relaxed text-cocoa-soft" data-id="element-32" data-mp="9jslqoe75gdm">{bono.desc}</p>
                  <p className="mt-3 text-xs font-semibold text-cocoa-dim" data-id="element-33" data-mp="25mxce1thfsml">
                    Valor <span className="line-through" data-id="element-34" data-mp="21llgxfnxgd6h">{bono.price}</span> ·{' '}
                    <span className="text-terra-deep" data-id="element-35" data-mp="2fmxvpnrcq8qs">hoy incluido</span>
                  </p>
                </div>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={80} className="mt-8 text-center" data-id="element-36" data-mp="2alia9ul9i07v">
          <p className="inline-block rounded-2xl bg-cream-deep px-5 py-3 text-sm font-bold leading-snug text-cocoa sm:rounded-full sm:px-6" data-id="element-37" data-mp="1mys72px6fzlo">
            Bonos valuados en <span className="text-cocoa-dim line-through" data-id="element-38" data-mp="1wna5x1lwbwmo">{PRICING.bonusValueOld}</span>{' '}
            <span className="text-terra-deep" data-id="element-39" data-mp="1rwtufn1myl2y">— incluidos sin costo</span>
          </p>
        </Reveal>
      </div>
    </section>;
}